import isDCHCustomerAssistancePlanEnrolled from './isDCHCustomerAssistancePlanEnrolled';
import { isWaivedInterestAvailableForAutopay } from './parseEligibility';
import { isPayLaterProduct, isSecuredInstallmentLoanProduct } from './productTypeHelpers';
const isAutopayPaymentAmountOptionMutable = (eligibility, productType, featureFlags, billing) => {
    if (isPayLaterProduct(productType)) {
        return isWaivedInterestAvailableForAutopay(eligibility);
    }
    if (isDCHCustomerAssistancePlanEnrolled(billing, productType, featureFlags)) {
        return false;
    }
    return !isSecuredInstallmentLoanProduct(productType);
};
export default isAutopayPaymentAmountOptionMutable;
